var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video_play",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-play",
    "data-name": "Icon ionic-ios-play",
    d: "M9,7.377V30.3a.59.59,0,0,0,.884.544L28.058,19.384a.649.649,0,0,0,0-1.081L9.884,6.841A.585.585,0,0,0,9,7.377Z",
    transform: "translate(24.316 21.191)",
    fill: "#23262f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2407",
    "data-name": "Ellipse 2407",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#23262f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/video_play.dfacec9821a803a314e69cde0d4dea20.svg";
export { ForwardRef as ReactComponent };